<script lang="ts" setup>
import IconArrowIosDown from 'theme/assets/icons/fill/arrow-ios-down.svg?component';
import IconArrowIosUp from 'theme/assets/icons/fill/arrow-ios-up.svg?component';

defineProps<{
  num: number;
}>();

const isOpen = ref(false);

const onClick = () => (isOpen.value = !isOpen.value);
</script>

<template>
  <div :class="$style.container">
    <div :class="[$style.container__title, $style.title]" @click="onClick">
      <div :class="[$style.title__point, $style.point]">
        <div :class="$style.point__text">POINT</div>
        <div :class="$style.point__num">{{ num }}</div>
      </div>
      <div :class="[$style.title__titleText, $style.titleText]">
        <slot name="title" />
      </div>
      <div v-if="!isOpen" :class="[$style.title__seeNext, $style.seeNext]">
        <span :class="$style.seeNext__text">続きを見る</span
        ><IconArrowIosDown
          :class="[$style.seeNext__IconArrowIos, $style.IconArrowIos]"
        />
      </div>
      <div v-else :class="[$style.title__seeNext, $style.seeNext]">
        <span :class="$style.seeNext__text">閉じる</span>
        <IconArrowIosUp
          :class="[$style.seeNext__IconArrowIos, $style.IconArrowIos]"
        />
      </div>
    </div>
    <div v-show="isOpen" :class="[$style.container__content, $style.content]">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  padding: 32px;
  border: 3px solid $color-border-accent-primary;
  border-radius: 16px;

  &__content {
    margin-top: 16px;
  }

  @include mobile-only {
    padding: 16px;
  }
}

.title {
  display: flex;
  align-items: center;
  gap: 10px;

  &__titleText {
    width: 100%;
    font-size: 28px;
    line-height: 42px;
    color: $color-text-and-object-high-emphasis;

    @include mobile-only {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__seeNext {
    flex-shrink: 0;
  }
}

.point {
  &__text {
    font-size: 12px;
    line-height: 12px;
    font-weight: bold;
    color: $color-text-and-object-accent-primary;
  }

  &__num {
    margin-top: 2px;
    text-align: center;
    font-size: 20px;
    line-height: 32px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: $color-text-and-object-high-emphasis-inverse;
    background-color: $color-text-and-object-accent-primary;
  }
}

.content {
  font-size: 16px;

  &__inner {
    margin-top: 16px;
  }

  p {
    margin-bottom: 1em;
    line-height: 1.8;
  }

  a {
    text-decoration: underline;
  }

  h3 {
    font-size: 24px;
    line-height: 43.2px;
    margin-top: 1.5em;
  }
  h4 {
    font-size: 18px;
    margin-top: 0.25em;
    margin-bottom: 0.5em;
  }
  img {
    width: 100%;
    max-width: 600px;
    display: block;
    cursor: pointer;
  }
}

.seeNext {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  font-weight: bold;
  line-height: 28.8px;
  color: $color-text-and-object-accent-primary;
  cursor: pointer;

  &__text {
    @include mobile-only {
      display: none;
    }
  }

  &__IconArrowIos {
    fill: $color-text-and-object-accent-primary;
  }
}
</style>
